export default {
  options(h, conf, key) {
    const list = []
    conf.bpmSlot.options.forEach(item => {
      list.push(<my-checkbox label={item.value} border={conf.border}>{item.label}</my-checkbox>)
    })
    return list
  }
}
